import { Card, Col, Row, Button } from "antd";
import React, { useEffect, useState } from "react";
import { ExportOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { getAllEndorsementCalculations } from "../../../Action/EndorsementcalcApi";
import moment from "moment";
import { downloadCSV } from "../../FileSaver/FileSaver";
import EndorseList from "./EndorseList";

// Accept the onAddEndorsement prop from the parent
const Index = ({ onAddEndorsement }) => { 
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    document.title = "Endorsement List";
    fetchEndorsements(pagination.current, pagination.pageSize);
  }, [dispatch, pagination.current, pagination.pageSize]);

  const fetchEndorsements = (page, pageSize) => {
    setLoading(true);
    dispatch(getAllEndorsementCalculations(page, pageSize))
      .then((res) => {
        const list = res?.data?.data || [];

        const mappedData = list.map((item) => {
         
          return {
            corporate: item.corporate_name,
            transaction_statement: item.transaction_statements,
            addition_premium: item.total_addition_premium,
            deletion_premium: item.total_deletion_premium,
            net_premium: item.net_premium,
            endorsement_title: item.endorsement_title, // Displaying as plain text
            endorsement_number: item.endorsement_number,
            created_at: moment(item.created_at).format("DD-MM-YYYY"),
            key: item.ref_endorsment_calculation_data_upload_id || item.id,
            originalRecord: item,
          };
        });

        setFilteredData(mappedData);
        setPagination((prev) => ({
          ...prev,
          current: res?.data?.current_page || page,
          total: res?.data?.total || 0,
          pageSize: res?.data?.per_page || pageSize,
        }));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch endorsements:", error);
        setLoading(false);
      });
  };

  const handleDownloadCSV = () => {
    const csvData = filteredData.map(item => ({
        'Corporate Name': item.corporate,
        'Endorsement Title': item.endorsement_title,
        'Endorsement Number': item.endorsement_number,
        'Transaction Statement': item.transaction_statement,
        'Addition Premium': item.addition_premium,
        'Deletion Premium': item.deletion_premium,
        'Net Premium': item.net_premium,
        'Created At': item.created_at,
    }));
    downloadCSV(csvData, "endorsement_calculation_list.csv");
  };

  const handleTableChange = (newPagination) => {
    setPagination((prev) => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    }));
  };

  const handlePolicyAction = (record) => {
    console.log("Clicked Mapped Record:", record);
    console.log("Original API Record:", record.originalRecord);
  };

  return (
    <div className="site-card-wrapper">
      <Row gutter={16}>
        <Col style={{ width: "100%" }}>
          <Card
            title={
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span className="corp-title">Endorsement List</span>
                <div className="d-flex gap-3">
                  
                  <Button type="primary" onClick={onAddEndorsement}>
                    Add Endorsement
                  </Button>
                  <Button
                    type="primary"
                    onClick={handleDownloadCSV}
                    icon={<ExportOutlined />}
                    className="d-flex"
                  >
                    Export
                  </Button>
                </div>
              </div>
            }
            bordered={false}
          >
            <EndorseList
              loading={loading}
              filteredData={filteredData}
              handlePolicyAction={handlePolicyAction}
              pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: pagination.total,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50'],
                onChange: (page, pageSize) =>
                  handleTableChange({ current: page, pageSize }),
                showTotal: (total, range) =>
                  `Showing ${range[0]} to ${range[1]} of ${total} entries`,
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Index;